module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/home/home-address-artwork-201a1bdd5327fb925c1dbde0f292038e.svg";